import styled from 'styled-components';
import Slider from 'react-slick';
import { useDispatch, useSelector } from 'react-redux';
import { digestSliderControls, sliderArrowIcon } from 'Utils/utilsStyle';

import { useEffect } from 'react';
import { actions as customWidgetActions } from 'Slice/CustomWidgetSlice';
import { selectCustomWidgetData, selectCustomWidgetLoading } from 'Selector/CustomWidgetSelector';
import DigestTile from './DigestTile';
import SkeletonCustom from '../skeleton/SkeletonCustom';
import GenpactWidgetIcon from '../assets/svgIcons/GenpactWidgetIcon';

const Wrapper = styled.div`
  .heading-inner-page {
    .heading {
      display: flex;
      align-items: center;
      margin-top: 40px;
      svg {
      margin-right: 10px;
      }
    }
  }
 
  .slick-slide-wrap {
    margin-bottom: 40px;
    > .slick-list {
      > {
        .slick-track {
          margin-left:0;
        }
      }
    }
    .slick-disabled {
      display: none !important;
    }
    .slick-arrow {
      &.slick-prev {
        z-index: 1;
        &:before {
          height: 32px;
          width: 18px;
          background-image: url(${sliderArrowIcon});
          content: '';
          position: absolute;
          top: 0px;
          left: 10px;
          transform: rotate(-180deg);
        }
        &:after {
          content: '';
          width: 60px;
          height: 218px;
          background-image: linear-gradient(to right,
           rgba(0, 0, 0, 0.6),
            rgba(0, 0, 0, 0.4),
             rgba(0, 0, 0, 0.2), 
             rgba(238, 238, 238, 0.2));
            position: absolute;
            right: -30px;
            top: -99px;
            z-index: -1;
            border-radius: 10px 0px 0px 10px;
        }
      }
      &.slick-next {
        &:before {
          height: 32px;
          width: 18px;
          background-image: url(${sliderArrowIcon});
          content: '';
          position: absolute;
          top: 0px;
          right: 10px;
        }
        &:after {
          content: '';
          width: 60px;
          height: 219px;
          background-image: linear-gradient(to right, rgba(238, 238, 238, 0.2),
           rgba(0, 0, 0, 0.2),
            rgba(0, 0, 0, 0.4),
             rgba(0, 0, 0, 0.6));
          position: absolute;
          right: -10px;
          top: -100px;
          z-index: -1;
          border-radius: 10px 0px 0px 10px;
        }
      }
    }
  }
  .skeleton-box {
    margin-right: 10px;}
  .heading-inner-page{
    margin-bottom: 10px;
  }
  .slick-prev {
    left: 10px;
  }
  .slick-next {
    right: 10px;
  }
`;

const DigestCustomWidget = function DigestCustomWidget() {
  const dispatch = useDispatch();
  const isLoading = useSelector(selectCustomWidgetLoading);
  const widgetData = useSelector(selectCustomWidgetData);

  useEffect(() => {
    if (!widgetData.length) { dispatch(customWidgetActions.getCustomWidgetData()); }
  }, []);

  const getArticleSkeleton = () => (
    [1, 2, 3, 4, 5].map(() => (
      <span className="resolution-fix digest-skelton-fix">
        <SkeletonCustom
          width="240px"
          height="218px"
        />
      </span>
    ))
  );

  const getDigestWidgets = () => (widgetData?.length
    ? (
      <Slider {...digestSliderControls} className="slick-slide-wrap ">
        {widgetData?.map((widget) => (
          <DigestTile
            widgetId={widget.widgetId}
            imagesURL={widget.articles?.slice(0, 3)
              .flatMap((article) => article.image || [])
              .filter((image): image is string => Boolean(image))}
            title={widget.title}
          />
        ))}
      </Slider>
    ) : null
  );

  return (
    <Wrapper>
      <div className="heading-inner-page">
        {isLoading
          ? <SkeletonCustom height="20px" width="200px" margin="0px 0px 10px 0px" />
          : (widgetData.length > 0
            && (
              <h1 className="heading ">
                <GenpactWidgetIcon />
                Digests
              </h1>
            )
          )}
      </div>
      {isLoading ? (getArticleSkeleton()) : (
        getDigestWidgets()
      )}
    </Wrapper>
  );
};

export default DigestCustomWidget;
